import { render, staticRenderFns } from "./EventPlacements.vue?vue&type=template&id=f4808e28&scoped=true&"
import script from "./EventPlacements.vue?vue&type=script&lang=js&"
export * from "./EventPlacements.vue?vue&type=script&lang=js&"
import style0 from "./EventPlacements.vue?vue&type=style&index=0&id=f4808e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4808e28",
  null
  
)

export default component.exports